<template>
  <div>
    <div
      :key="message.id"
      :class="[
        message.role === 1 ? 'assistant' : 'user',
        message.status === 'ERROR' ? 'error' : ''
      ]"
    >
      <!-- Пока не пришёл первый чанк ответа - показываем анимацию "печатает" -->
      <div v-if="message.status === 'chunk' && !message.text" class="thinking-dots">
        <span></span><span></span><span></span>
      </div>

      <!-- Если статус chunk - показываем печать -->
      <typing-text v-else-if="message.status === 'chunk'" :text="message.text" />

      <!-- Если статус обычный -->
      <div v-else v-html="msg.html"></div>

      <!-- Блок источников -->
      <div v-if="message.citations && message.citations.length" class="citations">
        <h4>Читать:</h4>
        <ul>
          <li v-for="(citation, index) in message.citations" :key="index">
            <a :href="citation.url" target="_blank" rel="noopener noreferrer">
              {{ citation.name }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import imageGallery from './message-image-gallery.vue';
import TypingText from './typing-text.vue';
import MarkdownIt from 'markdown-it';

const md = new MarkdownIt({
  html: true,
  linkify: true,
  typographer: true
});

// … твой кастомный markdown рендерер

export default {
  props: {
    message: { type: Object, required: true }
  },
  components: {
    imageGallery,
    TypingText
  },
  computed: {
    msg() {
      return { html: md.render(this.message.text) };
    }
  }
};
</script>

<style scoped>
.user {
    margin-left: 20px;
    background-color: #3373fd;
    color: white;
    padding: 0px 15px 0px 15px; 
    border-radius: 12px 12px 12px 12px;
    font-family: sans-serif;
    margin-top: 10px;
    width: fit-content;
    text-align: right;
    float: right;
}

.assistant {
    margin-left: 20px;
    text-align: left;
    float: left;
    margin-top: 10px;
    background-color: #f1f5f9;
    color: #1e293b;
    padding: 12px;
    max-width: 70%;
    border-radius: 12px 12px 12px 12px;
    width: fit-content;
    font-family: sans-serif;
}

.error {
  background-color: #ffdddd !important;
  color: #b00020 !important;
  border: 1px solid #b00020;
}

.assistant >>> .chat-image {
  border-radius: 10px;
  max-width: 100%;
  height: auto;
  max-height: 150px;
}

.citations {
  margin-top: 1em;
  padding: 0.8em 0.8em 0.1em 0.8em;
  background-color: #f9f9f9;
  border-left: 4px solid #007bff;
  border-radius: 4px;
  font-size: 0.85em;
}

.citations h4 {
  margin: 0 0 0.5em;
  font-weight: bold;
  color: #333;
}

.citations ul {
  padding-left: 1.2em;
  list-style-type: disc;
}

.citations li {
  margin-bottom: 0.3em;
}

.citations a {
  color: #007bff;
  text-decoration: none;
  transition: color 0.2s ease;
}

.citations a:hover {
  color: #0056b3;
  text-decoration: underline;
}

.thinking-dots {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 2px;
}

.thinking-dots span {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: #94a3b8;
  animation: thinking-bounce 1.2s infinite ease-in-out both;
}

.thinking-dots span:nth-child(1) {
  animation-delay: -0.24s;
}

.thinking-dots span:nth-child(2) {
  animation-delay: -0.12s;
}

@keyframes thinking-bounce {
  0%, 80%, 100% {
    transform: scale(0.6);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/message.vue